import Common from "../../../Common";
import Button from "./device/Button";

const Device = class extends Common {
	button: InstanceType<typeof Button>;

	constructor(headers: ApiHeaders) {
		super(headers)
		this.button = new Button(headers);
	}

	browse = (companyId: id): CustomResponse<Device[]> =>
		this.get(`/company/${companyId}/pbx/device`);

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/device/${id}`);

	create = (companyId: id, data: any) =>
		this.post(`/company/${companyId}/pbx/device`, data);

	update = (companyId: id, id: id, data: any) =>
		this.patch(`/company/${companyId}/pbx/device/${id}`, data);

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbx/device/${id}`);
}

export default Device
